<template>
    <div class="templete">
        <div class="search_box no_print clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd"
                    class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd"
                    class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_out_time" value-format="timestamp" format="yyyy-MM-dd"
                    class="search_time_input" type="date" placeholder="开始出库日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_out_time" value-format="timestamp" format="yyyy-MM-dd"
                    class="search_time_input" type="date" placeholder="结束出库日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.search.order_sn" clearable
                placeholder="销售单号"></el-input>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.salesman_id"
                clearable placeholder="销售人" @visible-change="getSalemanList">
                <!-- multiple collapse-tags  -->
                <el-option v-for="list in saleManList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <select-down-customer ref="selectdowncustomer" class="searchCustomer"
                @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
            <el-select class="search_select search_inputBox search_inputBox_long"
                v-model="params.search.sign_order_status" clearable placeholder="签单状态">
                <el-option :value="0" :label="'未签'"></el-option>
                <el-option :value="1" :label="'已签'"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-if="isShowMore"
                v-model="params.search.contract_status" clearable placeholder="合同状态">
                <el-option :value="0" :label="'未签'"></el-option>
                <el-option :value="1" :label="'已签'"></el-option>
            </el-select>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button class="publicBtn" @click="search">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList clearfix">
            <el-button class="funcPublicBtn funcPublicBtnChecked" @click="Addsign()">签单上传</el-button>
            <el-button class="funcPublicBtn funcPublicBtnChecked" @click="Addcontract()">合同上传</el-button>
            <div class="upimgBtnBox">
                <el-tooltip class="item" effect="dark" placement="bottom">
                    <div slot="content">
                        <span>注:</span><br />
                        <span>1.销售统计（销售）:是销售单"财务审核"通过后统计的数据</span><br />
                        <span>2.销售汇总（销售）:是销售单"财务审核"通过后统计的数据</span><br />
                        <span>3.销售利润表（财务）:是销售单"财务审核"通过后统计的数据</span><br /><br />
                    </div>
                    <div class="tipImg" :label="0" border></div>
                </el-tooltip>
            </div>
        </div>
        <div class="tableBox no_print">
            <tabletem :isSetCol="true" scene="report.order.list" :isLoading="tableLoading" @getRow="selectChange"
                :tablecol="tableCol" :tabledata="list" @rowClick="rowClick" @sortTable="sortList"
                @relativefile="relativeFile"></tabletem>
        </div>
        <div class="text-center no_print">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total"
                :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="totalCal no_print">
            <div class="totalName">合计:</div>
            <div class="totalNumber" v-if="statistics.out_cube">出库方数：{{statistics.out_cube }}m³</div>
            <div class="totalNumber" v-if="statistics.sales_cube">销售方数: {{statistics.sales_cube }}m³</div>
            <div class="totalNumber" v-if="statistics.sales_amount">销售金额：¥{{statistics.sales_amount }}</div>
            <div class="totalNumber" v-if="statistics.purchase_amount">采购金额：¥{{statistics.purchase_amount }}</div>
            <div class="totalNumber" v-if="statistics.cost_amount">成本费用：¥{{statistics.cost_amount }}</div>
            <div class="totalNumber" v-if="statistics.warehouse_amount">仓储费：¥{{statistics.warehouse_amount }}</div>
            <div class="totalNumber" v-if="statistics.tax_manual">含税价税金: ¥{{statistics.tax_manual }}</div>
            <div class="totalNumber" v-if="statistics.reduce_amount">优惠金额: ¥{{statistics.reduce_amount }}</div>
            <!-- <div class="totalNumber" v-if="statistics.business_expense">销售费用: ¥{{statistics.business_expense }}</div> -->
            <div class="totalNumber" v-if="statistics.business_expense||Number(statistics.business_expense)==0">
                <div class="contractLabel">
                    <div class="labelTip" style="width:280px">
                        <div class="laCbelTipC">
                            关联销售单已审核的营业支出费用
                        </div>
                    </div>
                    <span>销售费用:¥{{statistics.business_expense }}</span>
                </div>
            </div>
            <div class="totalNumber" v-if="statistics.sales_margin||Number(statistics.sales_margin)==0">
                <div class="contractLabel">
                    <div class="labelTip" style="width:480px">
                        <div class="laCbelTipC">
                            销售金额-采购金额-成本费用-仓储费-含税价税金-优惠金额-销售费用
                        </div>
                    </div>
                    <span>销售利润:{{statistics.sales_margin}}</span>
                </div>
            </div>
            <div class="totalNumber"
                v-if="statistics.other_business_expense||Number(statistics.other_business_expense)==0">
                <div class="contractLabel">
                    <div class="labelTip" style="width:240px">
                        <div class="laCbelTipC">
                            与销售单无关的营业支出费用
                        </div>
                    </div>
                    <span>其他支出:{{statistics.other_business_expense}}</span>
                </div>
            </div>
            <div class="totalNumber" v-if="statistics.flip_profit||Number(statistics.flip_profit)==0">
                <div class="contractLabel">
                    <div class="labelTip" style="width:320px">
                        <div class="laCbelTipC">
                            订单已完成的原料成本金额-成品采购金额
                        </div>
                    </div>
                    <span>加工盈亏:{{statistics.flip_profit}}</span>
                </div>
            </div>
            <div class="totalNumber" v-if="statistics.company_margin||Number(statistics.company_margin)==0">
                <div class="contractLabel">
                    <div class="labelTip" style="width:250px">
                        <div class="laCbelTipC">
                            销售利润-其他支出-加工盈亏
                        </div>
                    </div>
                    <span>公司利润:{{statistics.company_margin}}</span>
                </div>
            </div>
            <!-- <div class="totalNumber" v-if="statistics.sales_margin">销售利润: ¥{{statistics.sales_margin }}</div> -->
        </div>
        <sale-bill-base :dialog="dialogVisible" @hide="dialogVisible=false" :dt="orderType" :form-data="detailInfo"
            :scene="'order.create.column'">
            <div class="editBtnList clearfix">
                <div style="float:left;margin-bottom: 10px;">
                    <!--<el-button class="funcPublicBtn" style="line-height: 25px;" v-if="module.includes(',finance-fee-manage-add,')">关联销售费用</el-button>-->
                    <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                        <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                            {{list.fee_name+': ￥'+list.amount}}
                        </div>
                    </div>
                </div>
                <div class="editBtn" style="margin-bottom: 10px;">
                    <el-button class="funcPublicBtn" @click="print(8)">合同打印</el-button>
                    <el-button class="funcPublicBtn" @click="print(0)">打印</el-button>
                </div>
            </div>
        </sale-bill-base>
        <filter-fields :tableData="filter" scene="report.order.list" :filterDialogVisible="filterDialogVisible"
            @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 上传文件 -->
        <el-dialog v-dialog-drag title="签单上传" :visible.sync="importSign" class="eldialog eldialogA" :modal="false"
            width='500px'>
            <div class="text-center" style="margin-top:20px;">
                <div class="upFileOutBox clearfix">
                    <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data"
                        :on-success="handleSuccess" :before-upload="beforeUpload">
                        <img src="/icon/upfile.png" class="uploadFileAdd">
                        <div class="uploadTitle">点击文件上传</div>
                    </el-upload>
                    <div class="upFileBox clearfix" v-for="(item,index) in upFileList" :key="index+'_index'">
                        <div class="upFile">{{item.name}}</div>
                        <img src="/icon/top-delete-suspension.png" class="upFileRemove"
                            @click="upFileRemove(item.url)" />
                        <div class="upFileUnder"></div>
                        <div class="upFileTop"></div>
                        <div class="upFileLeft"></div>
                        <div class="upFileRight"></div>
                    </div>
                </div>
                <!-- <ym-upload :acType="2" :limit="10" @getFileData="getFileData" :initList="initList"></ym-upload> -->
                <!-- <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx,.txt,image/jpeg,image/png">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div>
				</el-upload> -->
            </div>
            <div class="dialogBtnList clearfix">
                <el-button class="publicBtn dialogBtn" @click="SignYes">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importSign=!importSign">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag title="合同上传" :visible.sync="importContract" class="eldialog eldialogA" :modal="false"
            width='500px'>
            <div class="text-center" style="margin-top:20px;">
                <div class="upFileOutBox clearfix">
                    <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data"
                        :on-success="handleSuccess" :before-upload="beforeUpload">
                        <img src="/icon/upfile.png" class="uploadFileAdd">
                        <div class="uploadTitle">点击文件上传</div>
                    </el-upload>
                    <div class="upFileBox clearfix" v-for="(item,index) in upFileList" :key="index+'_index'">
                        <div class="upFile">{{item.name}}</div>
                        <img src="/icon/top-delete-suspension.png" class="upFileRemove"
                            @click="upFileRemove(item.url)" />
                        <div class="upFileUnder"></div>
                        <div class="upFileTop"></div>
                        <div class="upFileLeft"></div>
                        <div class="upFileRight"></div>
                    </div>
                </div>
                <!-- <ym-upload :acType="2" :limit="10" @getFileData="getFileData" :initList="initList"></ym-upload> -->
                <!-- <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx,.txt,image/jpeg,image/png">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div>
				</el-upload> -->
            </div>
            <div class="dialogBtnList clearfix">
                <el-button class="publicBtn dialogBtn" @click="contractYes">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importContract=!importContract">取消</el-button>
            </div>
        </el-dialog>
        <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}"
            :files="downFilesList"></relativeFile>
    </div>
</template>
<style scoped lang="scss">
    .templete {
        padding: 0;
    }

    .piaoMess {
        font-size: 12px;
        color: #777;
        margin-bottom: 10px;
    }

    .piaoMessC {
        float: left;
        width: 50%;
    }

    .bottom_flex {
        padding-right: 12px;
        padding-bottom: 8px;
    }

    .editPayBox {
        .editPay {
            width: 50%;
            float: left;
            height: 100px;
            box-sizing: border-box;
            padding: 10px;
        }

        .editName {
            font-size: 12px;
            color: #777;
            padding: 2px 0;
        }

        .editPay:nth-child(2n) {
            border-left: 1px solid #ccc;
        }
    }

    .editPersonBox {
        .editPerson {
            width: 33%;
            float: left;
            font-size: 12px;
            color: #777;
            box-sizing: border-box;
            padding: 5px 0;
        }
    }

    .editBtnList {
        padding-top: 10px;

        .editTax {
            float: left;
        }

        .editTaxname {
            float: left;
            font-size: 12px;
            color: #777;
            line-height: 25px;
            margin-right: 5px;
        }

        .editTaxinput {
            float: left;
            width: 100px;
        }

        .editBtn {
            float: right;
        }
    }

    .totalNumber {
        margin-right: 10px;
    }

    .totalName {
        margin-right: 10px;
    }

    .contractLabel {
        position: relative;
    }

    .contractLabel:hover {
        cursor: pointer;
        color: #b21111;
    }

    .contractLabel:hover .labelTip {
        display: block;
    }

    .labelTip {
        display: none;
        position: absolute;
        font-weight: 600;
        top: -65px;
        left: -50px;
        z-index: 1;
        width: 180px;
        text-align: left;
        border-radius: 4px;
        padding: 10px;
        box-sizing: border-box;
        box-shadow: 1px 1px 5px #ccc;
        padding-left: 30px;
        z-index: 100;
        background-color: #000;
        opacity: 0.8;
        color: aliceblue;
    }

    .upFileOutBox .upFileBox {
        width: 100%;
        margin-bottom: 10px;
        border-radius: 5px;
        box-shadow: 0 0 5px #ccc;
        padding: 2px 10px;
        margin-top: 10px;
    }

    .upFileOutBox .upFile {
        display: block;
        float: left;
        font-size: 14px;
    }

    .upFileOutBox .upFileRemove {
        width: 15px;
        height: 15px;
        float: right;
        cursor: pointer;
        margin-top: 2px;
    }

    .upFileOutBox .uploadFileAdd {
        width: 60px;
        height: 50px;
        display: block;
        margin: auto;
        margin-top: 60px;
    }

    .upFileOutBox .upload-demo {
        width: 100%;
        height: 180px;
        overflow: hidden;
    }

    .upFileOutBox .uploadTitle {
        width: 100%;
        text-align: center;
        font-size: 14px;
        margin-top: 5px;
    }

    .upFileBox:hover {
        transform: translateY(-2px);
        cursor: pointer;
    }

    .upFileUnder {
        width: 0;
        height: 0;
        transition: 0.3s ease-out;
        position: absolute;
        right: 0;
        margin: auto;
        bottom: 0;
        border-radius: 35px;
    }

    .upFileTop {
        width: 0;
        height: 0;
        transition: 0.3s ease-out;
        position: absolute;
        left: 0;
        margin: auto;
        top: 0;
        border-radius: 35px;
    }

    .upFileLeft {
        width: 0;
        height: 0;
        transition: 0.3s ease-out;
        position: absolute;
        left: 0;
        margin: auto;
        bottom: 0;
        border-radius: 35px;
    }

    .upFileRight {
        width: 0;
        height: 0;
        transition: 0.3s ease-out;
        position: absolute;
        right: 0;
        margin: auto;
        top: 0;
        border-radius: 35px;
    }

    .upFileBox:hover .upFileUnder {
        width: 100%;
        height: 0;
        border-top: 1px solid #b21111;
    }

    .upFileBox:hover .upFileTop {
        width: 100%;
        height: 0;
        border-top: 1px solid #b21111;
    }

    .upFileBox:hover .upFileLeft {
        width: 0;
        height: 100%;
        border-left: 1px solid #b21111;
    }

    .upFileBox:hover .upFileRight {
        width: 0;
        height: 100%;
        border-left: 1px solid #b21111;
    }
</style>
<script>
    import tabletem from '../../../components/table.vue';
    import pagination from '../../../components/pagination.vue';
    import selectDownCustomer from '../../../components/selectDownCustomer.vue';
    import saleBillBase from '../../../components/saleBillBase';
    import relativeFile from '../../../components/downloadRelativeFile.vue'


    const initSearchParams = {
        page: 1,
        per_page: 50,
        search: {
            order_sn: "",
            start_time: "",
            end_time: "",
            start_out_time: "",
            end_out_time: "",
            customer_id: "",
            salesman_id: "",
            sign_order_status: "",
            contract_status: ""
        }
    };
    export default {
        components: {
            tabletem,
            pagination,
            selectDownCustomer,
            saleBillBase,
            relativeFile
        },
        data() {
            return {
                tableLoading: false,
                module: localStorage.dw_erp_power_code,
                enableConfig: localStorage.dw_erp_enable_config,
                companyName: localStorage.dw_erp_company_name,
                start_time: "",
                end_time: "",
                start_out_time: "",
                end_out_time: "",
                customerList: [],
                saleManList: [],
                params: this.$cloneJson(initSearchParams),
                last_page: 1,
                current_page: 1,
                total: 0,
                statistics: {
                    total_cube: 0,
                    total_amount: 0,
                    total_count: 0
                },
                printDetail: {
                    fields: ""
                },
                printTotal: [],
                list: [],
                tableCol: [
                    { colName: "单据日期", colKey: "sales_time", colWidth: 100, isColor: true, isDate: true },
                    { colName: "出库日期", colKey: "out_time", colWidth: 100, isColor: true, isDate: true },
                    { colName: "销售单号", colKey: "order_sn", colWidth: 190, isCanClick: true, isColor: true, isSort: true },
                    { colName: "销售人", colKey: "salesman_name", colWidth: 102, isColor: false },
                    { colName: "客户名称", colKey: "customer_name", colWidth: 111, isColor: false },
                    { colName: "件数", colKey: "count", colWidth: 70, isColor: false },
                    { colName: "方数", colKey: "sales_cube", colWidth: 116, isColor: false },
                    { colName: "销售金额", colKey: "sales_amount", colWidth: 115, isColor: false },
                    { colName: "采购金额", colKey: "purchase_amount", colWidth: 115, isColor: false },
                    { colName: "成本费用", colKey: "cost_amount", colWidth: 115, isColor: false },
                    { colName: "优惠", colKey: "reduce_amount", colWidth: 115, isColor: false },
                    { colName: "仓储费", colKey: "warehouse_amount", colWidth: 115, isColor: false },
                    { colName: "含税价税金", colKey: "tax_manual", colWidth: 115, isColor: false },
                    { colName: "销售费用", colKey: "business_expense", colWidth: 115, isColor: false },
                    { colName: "销售利润", colKey: "sales_margin", colWidth: 115, isColor: false },
                    { colName: "利润率", colKey: "margin_rate", colWidth: 115, isColor: false },
                    { colName: "制单人", colKey: "creator_name", colWidth: 116, isColor: false },
                    { colName: "审核人", colKey: "auditor_name", colWidth: 116, isColor: false },
                    { colName: "出库人", colKey: "out_operator_name", colWidth: 116, isColor: false },
                    { colName: "备注", colKey: "remark", colWidth: 155, isColor: false },
                    { colName: "签单状态", colKey: "sign_order_status_text", colWidth: 100, isPoint: true, isColor: true },
                    { colName: "上传时间", colKey: "sign_order_time", colWidth: 100, isColor: false, isDate: true },
                    { colName: "签单详情", colKey: "sign_order", colWidth: 100, isSetWidth: true, isCanClick: false, isShow: true, isSignFile: true },
                    { colName: "合同状态", colKey: "contract_status_text", colWidth: 100, isPoint: true, isColor: true },
                    { colName: "上传时间", colKey: "contract_time", colWidth: 100, isColor: false, isDate: true },
                    { colName: "合同详情", colKey: "contract", colWidth: 100, isColor: true, isCanClick: false, isColor: true, isSignContract: true, },
                ],

                // detail start
                boardAmericaType: localStorage.dw_erp_board.includes("board-america"),
                boardAfricaType: localStorage.dw_erp_board.includes("board-africa"),
                categoryRawType: localStorage.dw_erp_category.includes("raw"),
                categoryBoardType: localStorage.dw_erp_category.includes("board"),
                dialogVisibleRelation: false,
                dialogVisible: false,
                // detail end
                bill: {},
                newFee: [],
                orderType: 3,
                detailInfo: {},
                //导入 start
                importSign: false,
                importContract: false,
                upload_data: {},
                oss: {
                    host: "",
                },
                file_url: '',
                //导入 end
                selectList: [],
                filterDialogVisible: false,
                filter: "",
                fields: "",
                status: 0,
                isShowMore: false,
                filesList: [],//多个上传文件
                initList: [],
                downLoadFileDialog: false,
                downFilesList: [],

                isUpImg: 0,
                upFileList: [],
            }
        },
        mounted() {
            this.start_time = this.$getCurrentMonthStartValueOf();
            this.end_time = new Date();
            this.search()
        },
        methods: {
            print(type) {
                let url = "/saleOrderPrint?id=" + this.detailInfo.id + "&category=" + type;
                window.open(url);
            },
            exportExcelBill() {
                this.$exportExecl("/erp/export.summarizing.sales.order", "销售汇总(销售单)", this.params)
            },
            getPage(obj) {
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            // Addsign(){
            //     if(this.selectList.length<1){
            //         this.tip("请选择销售单","warning")
            //     } else if(this.selectList.length>1){
            //         this.tip("选择数量不能大于" + 1 + "条","warning")
            //     }else{
            //         this.initList=this.selectList[0].sign_order;   
            //         this.importSign = true

            //     }
            // },
            // getFileData(data){
            //     this.filesList = data;
            // },
            // SignYes(){
            //     let arr = []
            //     this.selectList.forEach(item=>{
            //         arr.push(item.id)
            //     })
            //     this.postFunc('erp/order.upload.sign',{id:Number(arr),file:this.filesList},()=>{
            //         this.tip("上传成功","success")
            //         this.getList()
            //         this.initList=[];   
            //         this.importSign=false;
            //     })
            // },
            // Addcontract(){
            //     if(this.selectList.length<1){
            //         this.tip("请选择销售单","warning")
            //     } else if(this.selectList.length>1){
            //         this.tip("选择数量不能大于" + 1 + "条","warning")
            //     }else{
            //         this.initList= this.selectList[0].contract;   
            //         this.importContract = true
            //     }
            // },
            // contractYes(){
            //     let arr = []
            //     this.selectList.forEach(item=>{
            //         arr.push(item.id)
            //     })
            //     this.postFunc('erp/order.upload.contract',{id:Number(arr),file:this.filesList},()=>{
            //         this.tip("上传成功","success")
            //         this.getList()
            //         this.initList=[];   
            //         this.importContract=false;
            //     })
            // },
            //签单上传
            Addsign() {
                if (this.selectList.length < 1) {
                    this.tip("请选择销售单", "warning")
                } else if (this.selectList.length > 1) {
                    this.tip("选择数量不能大于" + 1 + "条", "warning")
                } else {
                    // this.initList=this.selectList[0].sign_order;   
                    // this.importSign = true
                    this.upFileList = Array.isArray(this.selectList[0].sign_order) ? JSON.parse(JSON.stringify(this.selectList[0].sign_order)) : [];
                    this.importSign = true;
                    this.isUpImg = 2;
                }

            },
            upFileRemove(url) {
                this.upFileList.forEach((item, index) => {
                    if (item.url == url) {
                        this.upFileList.splice(index, 1)
                    }
                })
            },
            SignYes() {
                let arr = []
                this.selectList.forEach(item => {
                    arr.push(item.id)
                })
                this.postFunc('erp/order.upload.sign', { id: Number(arr), file: this.upFileList }, () => {
                    this.tip("上传成功", "success")
                    this.getList()
                    this.importSign = false;
                })
            },
            //合同上传
            Addcontract() {
                if (this.selectList.length < 1) {
                    this.tip("请选择销售单", "warning")
                } else if (this.selectList.length > 1) {
                    this.tip("选择数量不能大于" + 1 + "条", "warning")
                } else {
                    this.upFileList = Array.isArray(this.selectList[0].contract) ? JSON.parse(JSON.stringify(this.selectList[0].contract)) : [];
                    this.importContract = true;
                    this.isUpImg = 2;
                }
            },
            contractYes() {
                let arr = []
                this.selectList.forEach(item => {
                    arr.push(item.id)
                })
                this.postFunc('erp/order.upload.contract', { id: Number(arr), file: this.upFileList }, () => {
                    this.tip("上传成功", "success")
                    this.getList()
                    this.importContract = false;
                })
            },


            saveFile() {
                this.$confirm('是否确认上传?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.upFileObj.files = this.upFileList;
                    this.postFuncLoading("/erp/inventory.upload.files", this.upFileObj, () => {
                        this.tip('上传成功', 'success');
                        this.dialogVisibleFile = false;
                        this.getList()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },

            getList() {
                this.tableLoading = true;
                this.params.search.start_time = this.formatTimeZero(this.start_time);
                this.params.search.end_time = this.formatTimeZero(this.end_time);
                this.params.search.start_out_time = this.formatTimeZero(this.start_out_time);
                this.params.search.end_out_time = this.formatTimeZero(this.end_out_time);
                this.$postColumnList("/erp/report.order.list", this.params, response => {
                    this.list = response.data.data.list;
                    this.list.forEach((item, ind) => {
                        item.baseColor = "";
                        if (item.sign_order_status_text == '未签' && item.contract_status_text == '未签') {
                            item.baseColor = "red";
                        }
                    })
                    this.filter = response.data.data.column;
                    this.fields = "," + (response.data.data.fields.join(",")).toString() + ",";
                    this.tableCol.forEach(item => {
                        if (this.fields.indexOf("," + item.colKey + ",") != -1) {
                            item.isShow = true;
                        } else {
                            item.isShow = false;
                        }
                    })
                    this.total = response.data.data.total;
                    this.statistics = response.data.data.statistics;
                    this.last_page = response.data.data.last_page;
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                }, error => {

                })
            },
            filterConfirm() {
                this.getList()
            },
            //导入 start
            handleSuccess(res) {
                if (this.isUpImg == 2) {
                    let obj = new Object();
                    obj.url = res.data.base_url;
                    obj.name = res.data.filename.substring(res.data.filename.lastIndexOf("/") + 1, res.data.filename.length)
                    this.upFileList.push(obj)
                } else {
                    this.file_url = res.data.base_url;
                }
                // this.file_url = res.data.base_url;
                this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            // detail START
            rowClick(obj) {
                if (obj.name === 'order_sn') {
                    this.postFuncLoading("/erp/order.order", { id: obj.id }, res => {
                        this.orderType = 3;
                        let resD = res.data.data;
                        if (resD.rec_type == 'DIV') {
                            resD.rec_type = 2
                        } else {
                            resD.rec_type = 1
                        }
                        this.newFee = resD.fee_list;
                        this.detailInfo = resD;
                        this.detailInfo.saleOrderIsEdit = false;

                        this.dialogVisible = true;
                    }, error => {
                        this.tip(error.data.message, "warning");
                    });
                }
                if (obj.name === 'sign_order') {
                    window.open(obj.row.newSign_order)
                }
                if (obj.name === 'contract') {
                    window.open(obj.row.newContract)
                }
                if (obj.name === 'sign_order_status_text') {
                    if (obj.row.sign_order_status_text == '已签') {
                        this.status = 0
                    } else {
                        this.status = 1
                    }
                    this.postFuncLoading("/erp/report.order.sign.status.update", { id: obj.id, status: this.status }, () => {
                        this.tip("签单状态更新成功", "success")
                        this.getList()
                    })

                }
                if (obj.name === 'contract_status_text') {
                    if (obj.row.contract_status_text == '已签') {
                        this.status = 0
                    } else {
                        this.status = 1
                    }
                    this.postFuncLoading("/erp/report.order.contract.status.update", { id: obj.id, status: this.status }, () => {
                        this.tip("合同状态更新成功", "success")
                        this.getList()
                    })

                }
            },
            sortList(e) {
                this.$generalSortParams(this.params, e);
                this.getList();
            },
            // detail END
            search() {
                this.tableColCopy = this.$deepClone(this.tableCol);
                this.getList();
            },
            reset() {
                // this.start_time = "";
                // this.end_time = "";
                this.start_time = "";
                this.end_time = new Date();
                this.start_out_time = "";
                this.end_out_time = "";
                this.params = this.$cloneJson(initSearchParams);
                this.$refs['selectdowncustomer'].clearData();
                this.search();
            },
            selectChange(row) {
                this.selectList = row;
            },
            // 获取客户
            getCustomerList(visible) {
                if (visible) {
                    this.$getCustomerList(this.params.search.salesman_id).then(res => {
                        this.customerList = res.data.data;
                    })
                }
            },
            // 获取销售员
            getSalemanList(visible) {
                if (visible) {
                    this.$getSalemanList(this.params.search.customer_id, 1).then(res => {
                        this.saleManList = res.data.data;
                    })
                }
            },
            relativeFile(obj) {
                this.downLoadFileDialog = !this.downLoadFileDialog;
                this.downFilesList = obj.files;
            },
            getOss() {
                let self = this;
                return new Promise((resolve, reject) => {
                    window.axios.post(window.oss_url + "/tool/v1/oss.policy.get", {
                        operate_code: "shop-excel"
                    }).then((response) => {
                        if (response.data.code == 0) {
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key: self.oss.dir + "${filename}",
                                policy: self.oss.policy,
                                OSSAccessKeyId: self.oss.accessid,
                                success_action_status: "200",
                                callback: self.oss.callback,
                                signature: self.oss.signature,
                                'Cache-Control': self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(() => {
                        reject();
                    })
                })
            }

        },
        watch: {
            "params.page": function () {
                this.getList();
            },
            "params.per_page": function () {
                this.search();
            },
            "dialogVisible": function (val) {
                if (!val) {
                    this.detailInfo = {};
                    this.newFee = [];
                }
            }
        }
    }
</script>